export default process.env.MIX_APP_ENV ?? 'production';
